import { TooltipContent } from "components/metric-card";

export const COST_EFFICIENCY_TOOLTIPS: TooltipContent = {
  title: "Cost per KPI Unit",
  text: "How much capital is spent for each unit of improvement per year. Use it to compare similar initiatives — lower is better.",
  formula: "CapEx ÷ Expected Annual Improvement",
};
